import * as React from 'react';
import { useAuth } from 'auth';
import Zendesk, { ZendeskAPI } from 'react-zendesk';
import { useGetMappedUserLanguage } from '../language/use-get-mapped-user-language';
import { useGetZendeskAuth } from 'api/zendesk/get';
import { FrontendConfigFeaturesEnum, ZendeskAuthResponse } from 'oas/api';
import { useHasFeature } from 'api';
import { UseQueryResult } from '@tanstack/react-query';

export const ZenDesk: React.FC = () => {
    const { user } = useAuth();
    const authResponse: UseQueryResult<ZendeskAuthResponse> | undefined = useGetZendeskAuth();

    const [isZDloaded, setIsZDloaded] = React.useState(false);
    const vectorCoreHelpCenter = 'a18e100a-5532-4b15-813b-225eb53241f7';
    const openFieldWebHelpCenter = '9a1e2e81-cca2-46d3-95fc-83b94c5d3688';

    const userLanguage = useGetMappedUserLanguage();
    const showVectorCoreHelpCenter = useHasFeature(FrontendConfigFeaturesEnum.ShowCoreHelpCenter);

    const { indeterminate, isAuthenticated } = useAuth();
    const isLoading = indeterminate || !isAuthenticated;

    const [loggedIn, setLoggedIn] = React.useState<boolean>(false);

    React.useEffect(() => {
        if (user && authResponse && !isLoading && showVectorCoreHelpCenter !== null && isZDloaded) {
            const token = authResponse.data?.token;

            ZendeskAPI('messenger:set', 'conversationFields', [
                { id: '12632174829967', value: authResponse.data?.details?.level ?? 'standard' },
                { id: '12845595173775', value: authResponse.data?.details?.region ?? '' },
                { id: '12845632399119', value: authResponse.data?.details?.country ?? '' },
                { id: '12960687012495', value: authResponse.data?.details?.health_status_cs ?? '' },
                { id: '12960613481871', value: authResponse.data?.details?.health_status_ph ?? '' },
                { id: '12960688616847', value: authResponse.data?.details?.health_status_tc ?? '' },
                { id: '12960643081999', value: authResponse.data?.details?.sport ?? '' },
            ]);

            if (!loggedIn && token) {
                ZendeskAPI('messenger:set', 'locale', userLanguage);
                ZendeskAPI('messenger', 'loginUser', function (callback: (t: string) => void) {
                    callback(token);
                });

                setLoggedIn(true);
            }
        }
    }, [isLoading, showVectorCoreHelpCenter, isZDloaded, user, userLanguage, authResponse, loggedIn]);

    return (
        <>
            {/* previously this condition contained a check for process.env.REACT_APP_ENVIRONMENT !== 'dev' to aid with debugging locally
             if you are having issues with the widget consider re-enabling this check */}
            {!isLoading && showVectorCoreHelpCenter !== null ? (
                <>
                    <Zendesk
                        zendeskKey={showVectorCoreHelpCenter ? vectorCoreHelpCenter : openFieldWebHelpCenter}
                        onLoaded={() => setIsZDloaded(true)}
                    />
                </>
            ) : null}
        </>
    );
};
